import { ContractIAImportState, ContractIAImportUnloadState } from '../../states/Contract.IAImport.States';
import * as actions from '../../actions/Contract.IAImport.Actions';

export default function ContractIAImportGetLastReducer(
  state: ContractIAImportState | undefined,
  action: any
): ContractIAImportState {
  const currentState = state ?? ContractIAImportUnloadState;
  switch (action.type) {
    case actions.CONTRACT_IAIMPORT_GETLAST_REQUEST: {
      // The slice holds one process for the whole app, so a fetch for a
      // different contract must drop what is there or the previous contract's
      // process stays on screen until the response lands.
      const belongsToAnotherContract =
        currentState.lastProcess != null &&
        currentState.lastProcess.contractID !== action.contractId;

      return {
        ...currentState,
        isGettingLastProcess: true,
        successGettingLastProcess: undefined,
        failOnGettingLastProcess: false,
        error: undefined,
        lastProcess: belongsToAnotherContract ? null : currentState.lastProcess,
      };
    }
    case actions.CONTRACT_IAIMPORT_GETLAST_SUCCESS:
      return {
        ...currentState,
        isGettingLastProcess: false,
        successGettingLastProcess: true,
        failOnGettingLastProcess: false,
        // Puede ser null si no existe ningún proceso previo
        lastProcess: action.process ?? null,
      };
    case actions.CONTRACT_IAIMPORT_GETLAST_FAILURE:
      return {
        ...currentState,
        isGettingLastProcess: false,
        successGettingLastProcess: false,
        failOnGettingLastProcess: true,
        error: action.error,
      };
    default:
      return currentState;
  }
}
